import DownloadIcon from '@material-ui/icons/GetApp';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';

const exportButton = ( { automationId, exportText, exportType } ) => {
    return (
        <Tooltip title={exportText} placement="top">
            <IconButton onClick={exportType} data-automation-id={automationId}>
                <DownloadIcon />
            </IconButton>
        </Tooltip>
    );
};

exportButton.propTypes = {
    automationId: PropTypes.string,
    exportText: PropTypes.string,
    exportType: PropTypes.func.isRequired,
};

export default exportButton;
